import React, { useContext, useEffect, useMemo } from 'react'
import { uniq } from 'lodash'

import { Stack, Grid } from '@mui/material_modern'
import { useParams } from 'react-router-dom'

import store from 'state/store'
import { showFormModal } from 'state/ui'

import { useGetInventoryAdjustmentsQuery } from 'services/inventoryAdjustments'

import ContentLayoutContext from 'components/layouts/ContentLayoutContextProvider'
import AdjustmentsListGrid from 'components/generic/datagrid/AdjustmentsListGrid'

import FORM_MODALS from 'utils/ui/modals'
import { MODAL_VIEW_MODES } from 'utils/constants'
import { FORMAT_TYPES, formatNumberForDisplay } from 'utils/helpers'

const AdjustmentsList = () => {
  const { id } = useParams()
  const context = useContext(ContentLayoutContext)

  const { data: adjustmentsData, isLoading: isLoadingList } = useGetInventoryAdjustmentsQuery({})

  useEffect(() => {
    context.setContainerTitle('Adjustments')
  }, [])

  useEffect(() => {
    if (id) {
      store.dispatch(
        showFormModal({
          formModalName: FORM_MODALS.NEW_ADJUSTMENT,
          formModalProps: {
            viewMode: id === 'new' ? MODAL_VIEW_MODES.NEW : MODAL_VIEW_MODES.VIEW,
            navigateTo: '/app/inventory/adjustments',
          },
        }),
      )
    }
  }, [id])

  const transformedRows = useMemo(
    () =>
      (adjustmentsData?.Items ?? [])
        .slice()
        .sort((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate))
        .map(adjustment => {
          return {
            id: adjustment?.id,
            externalId: adjustment?.externalId,
            adjustmentLink: `/app/inventory/adjustments/${adjustment?.id}`,
            updatedAt: adjustment?.updatedAt ? new Date(adjustment.updatedAt) : null,
            effectiveDate: adjustment?.effectiveDate ? new Date(adjustment.effectiveDate) : null,
            materials: adjustment?.materials?.map(material => material?.materialType?.commonName).join(', '),
            material:
              uniq(adjustment?.materials?.map(m => m.materialTypeId)).length > 1
                ? 'Multiple'
                : adjustment?.materials[0]?.materialType?.commonName,
            wipChange:
              uniq(adjustment?.materials?.map(m => m.materialTypeId)).length > 1
                ? 'Multiple'
                : formatNumberForDisplay(adjustment?.materials[0]?.netWeight, {
                    format: FORMAT_TYPES.WEIGHT,
                  }),
            avgCostChange:
              uniq(adjustment?.materials?.map(m => m.materialTypeId)).length > 1
                ? 'Multiple'
                : formatNumberForDisplay(adjustment?.materials[0]?.netCost, {
                    format: FORMAT_TYPES.PRICE,
                    decimalPrecisionOverride: 4,
                  }),
          }
        }),
    [adjustmentsData],
  )
  return (
    <Stack>
      <Grid p={3} sx={{ height: '100%' }} container flexDirection="column">
        <AdjustmentsListGrid rows={transformedRows} loading={isLoadingList} />
      </Grid>
    </Stack>
  )
}

export default AdjustmentsList
